// ./src/components/features/Cars/CarStatusBadge/CarStatusBadge.tsx
import React from "react";
import { Badge, BadgeProps } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { CAR_STATUS_MAP } from "@/config/carStatuses";
import { AppIcon } from "@/components/generic";

// ============================================
// Types
// ============================================

export interface CarStatusBadgeProps extends Omit<BadgeProps, "color" | "children"> {
  /** Car status value from the database */
  value: number | string | null | undefined;

  /** Whether to show the icon */
  showIcon?: boolean;

  /** Use short label variant */
  short?: boolean;
}

// ============================================
// Component
// ============================================

export const CarStatusBadge: React.FC<CarStatusBadgeProps> = ({
  value,
  showIcon = false,
  short = false,
  size = "md",
  variant = "light",
  ...rest
}) => {
  const { t } = useTranslation(["common"]);

  const option = value != null ? CAR_STATUS_MAP[String(value)] : undefined;

  if (!option) return null;

  return (
    <Badge
      color={option.color}
      variant={variant}
      size={size}
      leftSection={
        showIcon ? <AppIcon iconName={option.iconName} size={12} /> : undefined
      }
      {...rest}
    >
      {t(`common:${short ? option.labelShortKey : option.labelKey}`)}
    </Badge>
  );
};